/**
 * Collection of helpful hints to display during board loading
 */

export const LOADING_HINTS = [
  'Right-click on a pixel to undo pending changes before applying them',
  'Use the mouse wheel or zoom controls to zoom in and out of the canvas',
  'Press F11 or use the fullscreen button to enter immersive mode',
  'Your daily pixel quota resets every 24 hours - use it wisely!',
  'Use the color picker at the bottom to select from available colors',
  'Click "Apply" to confirm your pixel changes, or "Cancel" to discard them',
  'View modification history to see all changes made to the board',
  'Use middle mouse button or drag to pan around the canvas',
  'Undo and redo buttons let you navigate through your change history',
  'Boards can be public or private - check board settings for privacy options',
  'You can place multiple pixels before applying them all at once',
  'The info display shows board dimensions and other useful information',
] as const;

/**
 * Get a random hint from the loading hints array
 */
export const getRandomHint = (): string => {
  const randomIndex = Math.floor(Math.random() * LOADING_HINTS.length);
  return LOADING_HINTS[randomIndex];
};

/**
 * Get all available hints
 */
export const getAllHints = (): readonly string[] => {
  return LOADING_HINTS;
};


